$(document).ready(function () {

	$.blockUI.defaults.message = LANG.aguarde;

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('.loading-container').fadeOut(500, function () {
			$(this).remove();
		});
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy) e a class do efeito desejado (ex: .load-img)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) { //is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) { //is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else { //is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');

	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	function numberWithZero(num) {
		if (num < 10) {
		  return "0" + num;
		} else {
		  return num;
		}
	  }
	  var headerSwiperEl = $('.slider-main_component.is-home-header');
	  if(headerSwiperEl.length){
		const headerSwiper = new Swiper(headerSwiperEl.find(".swiper.is-home-header")[0], {
		  speed: 300,
		  autoplay: {
			delay: 3000,
			disableOnInteraction: false,
			waitForTransition: true,
			pauseOnMouseEnter: false,
		  },
		  autoHeight: false,
		  effect: "fade",
		  crossFade: true,
		  followFinger: true,
		  freeMode: false,
		  slideToClickedSlide: false,
		  slidesPerView: 1,
		  spaceBetween: 0,
		  rewind: false,
		  loop: true,
		  /*autoplay: {
			  delay: 2500,
			  disableOnInteraction: false,
			  waitForTransition: true,
			  pauseOnMouseEnter: false,
			},*/
		  mousewheel: {
			forceToAxis: true
		  },
		  /*pagination: {
			  el: ".slider-gallery_numbers",
			  type: "fraction",
			},*/
		  breakpoints: {
			320: {
			  spaceBetween: 0
			  },
			480: {
			  spaceBetween: 0
			  }
			},
		  keyboard: {
			enabled: true,
			onlyInViewport: true
		  },
		  navigation: {
			nextEl: headerSwiperEl.find(".swiper-next")[0],
			prevEl: headerSwiperEl.find(".swiper-prev")[0],
			disabledClass: "is-disabled"
		  },
		  slideActiveClass: "is-active",
		  slideDuplicateActiveClass: "is-active",
		  /*renderCustom: function (swiper, current, total) {
		  return current + ' of ' + total;
		}*/
		on: {
		  beforeInit: function () {
			let numOfSlides = this.wrapperEl.querySelectorAll(".swiper-slide.is-home-header").length;
			  $(".swiper-number-total").text(numberWithZero(numOfSlides));
		  },
		}
		});
		  headerSwiper.on("slideChange", function (e) {
		  let slideNumber = numberWithZero(e.realIndex + 1);
		  $(".swiper-number-current").text(slideNumber);
		});
	  }
	  $(".slider-main_component").each(function (index) {
		let loopMode = false;
		if ($(this).attr("loop-mode") === "true") {
		  loopMode = true;
		}
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
		  sliderDuration = +$(this).attr("slider-duration");
		} 
		const swiperProjects = new Swiper($(this).find(".swiper.is-team")[0], {
		  speed: sliderDuration,
		  autoHeight: false,
		  followFinger: true,
		  freeMode: true,
		  slideToClickedSlide: false,
		  slidesPerView: "auto",
		  spaceBetween: 32,
		  rewind: false,
		  mousewheel: {
			forceToAxis: true
		  },
		  breakpoints: {
			320: {
			  spaceBetween: 16
			  },
			480: {
			  spaceBetween: 16
			  },
			991: {
			  spaceBetween: 32
			  }
			},
		  keyboard: {
			enabled: true,
			onlyInViewport: true
		  },
		  scrollbar: {
		  el: '.swiper-scrollbar',
		  draggable: true,
		},
		  pagination: {
			el: $(this).find(".swiper-bullet-wrapper")[0],
			bulletActiveClass: "is-active",
			bulletClass: "swiper-bullet",
			bulletElement: "button",
			clickable: true
		  },
		  navigation: {
			nextEl: $(this).find(".swiper-next")[0],
			prevEl: $(this).find(".swiper-prev")[0],
			disabledClass: "is-disabled"
		  },
		  slideActiveClass: "is-active",
		  slideDuplicateActiveClass: "is-active"
		});
	  });
	  $(".slider-main_component").each(function (index) {
		let loopMode = false;
		if ($(this).attr("loop-mode") === "true") {
		  loopMode = true;
		}
		let sliderDuration = 300;
		if ($(this).attr("slider-duration") !== undefined) {
		  sliderDuration = +$(this).attr("slider-duration");
		} 
		const swiperProjects = new Swiper($(this).find(".swiper.is-timeline")[0], {
		  speed: sliderDuration,
		  autoHeight: false,
		  followFinger: true,
		  freeMode: true,
		  slideToClickedSlide: false,
		  slidesPerView: "auto",
		  spaceBetween: 0,
		  rewind: false,
		  mousewheel: {
			forceToAxis: true
		  },
		  keyboard: {
			enabled: true,
			onlyInViewport: true
		  },
		  navigation: {
			nextEl: $(this).find(".swiper-next")[0],
			prevEl: $(this).find(".swiper-prev")[0],
			disabledClass: "is-disabled"
		  },
		  slideActiveClass: "is-active",
		  slideDuplicateActiveClass: "is-active"
		});
	  });


	if($('.home-header-left-container').length){
		var $original_span = $('.home-header-left-container').find('span');
		$original_span.addClass('will-be-blue-bold');
	  	var $clone = $('<div>');
	  	$clone.addClass('span-clone blue-bold').text($original_span.text());
	  	$original_span.append($clone);

		// Split text into spans
		let typeSplit = new SplitType("[text-split]", {
			types: "words, chars",
			tagName: "span"
	  	});
	  // Link timelines to scroll position
	  function createScrollTrigger(triggerElement, timeline) {
		// Reset tl when scroll out of view past bottom of screen
		ScrollTrigger.create({
		  trigger: triggerElement,
		  start: "top bottom",
		  onLeaveBack: () => {
			timeline.progress(0);
			timeline.pause();
		  }
		});
		// Play tl when scrolled into view (60% from top of screen)
		ScrollTrigger.create({
		  trigger: triggerElement,
		  start: "top 60%",
		  onEnter: () => timeline.play()
		});
	  }
	  
	  $("[letters-fade-in]").each(function (index) {
		let tl = gsap.timeline({ paused: true, delay: 0.8 });
		tl.from($(this).find(".char"), { opacity: 0, duration: 0.1, ease: "power1.out", stagger: { amount: 1 }, onComplete: function(){
		setTimeout(function(){
			//gsap.set(".will-be-blue-bold", { color: 'transparent' });
		  	//gsap.to(".span-clone", { opacity: 1, duration: 0.2, ease: "power1.out" });

			$(".will-be-blue-bold").addClass('blue-bold');
		}, 100);
		} });
		createScrollTrigger($(this), tl);
	  });
  
	  // Avoid flash of unstyled content
	  gsap.set("[text-split]", { opacity: 1 });
	}
	
});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}